import get from 'lodash/get';
import isEmail from 'validator/lib/isEmail';
import { downloadQuotePdf, getAccountDetailsByEmails } from '@atlassian/temp-proxies';
import { AnalyticsTrackAction, AnalyticsTrackSubject, sendAnalyticsEvent } from '@atlassian/temp-analytics';
import { Quote, QuoteStatus, FilterOption } from '@css-xp/graphtypes/src/generated-types-sxp';
import FileSaver from 'file-saver';

export const handleDownloadPDF = async (id: string, transactionAccountId: string, fileName: string) => {
  try {
    const pdfFileUrl = await downloadQuotePdf(id, transactionAccountId);
    const pdfOpt = document.createElement('a');
    if (pdfFileUrl) {
      pdfOpt.setAttribute('download', fileName);
      pdfOpt.setAttribute('href', pdfFileUrl);
      document.body.appendChild(pdfOpt);
      pdfOpt.click();
      document.body.removeChild(pdfOpt);
    }
  } catch (err: any) {
    return err;
  }
};

export const getDefaultFilterOptions = ({
  transactionAccountId,
  filterOptions,
}: {
  transactionAccountId: string;
  filterOptions: FilterOption;
}) => {
  return {
    and: [
      {
        key: 'sourceSystem',
        value: 'CCP',
      },
      {
        key: 'transactionAccountId',
        value: transactionAccountId,
      },
      ...(filterOptions?.and ?? []),
      {
        or: [...(filterOptions?.or ?? [])],
      },
    ],
    not: [
      {
        key: 'status',
        value: QuoteStatus.DRAFT,
      },
      ...(filterOptions?.not ?? []),
    ],
    or: [],
  };
};

export const getEccAaidFromEmailSearchInput = async (searchInput: string) => {
  const isValidEmail = isEmail(searchInput);
  if (!isValidEmail) return null;
  let emailSearchInput;
  try {
    const result = await getAccountDetailsByEmails({ emails: [searchInput] });
    emailSearchInput = result && get(result[0], 'account_id');
    return emailSearchInput;
  } catch (err) {
    return null;
  }
};
